import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";

const B2ctopupCreate = ()=>{
     const [sourceC2b, setSourceC2b ] = useState('');
     const [receiverB2c, setReceiverB2c ] = useState('');
     const [amount, setAmount ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('b2ctopup', {
            source_c2b:sourceC2b,
            receiver_b2c:receiverB2c,
            amount,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/b2ctopup'} />
    }
     return (
         <Wrapper pageTitle={"New B2ctopup"}>
            <InnerNav createLink={'/b2ctopupCreate'} listLink={'/b2ctopup'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Source C2B </span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SourceB2c"
                        onChange = {e => setSourceC2b(e.target.value)} >
                            <option value="0">Choose Paybill</option>
                            <option>600350</option>
                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Receiver B2C </span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ReceiverC2b"
                        onChange = {e => setReceiverB2c(e.target.value)} >
                            <option value="0">Choose Paybill</option>
                            <option>600150</option>
                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default B2ctopupCreate;